var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreenCheck = function SvgGreenCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28 14.34a.747.747 0 0 1-1.06 0l-4.235-4.235a1.125 1.125 0 0 1 0-1.59l.53-.53a1.125 1.125 0 0 1 1.591 0l2.644 2.643 7.144-7.143a1.125 1.125 0 0 1 1.59 0l.53.53a1.125 1.125 0 0 1 0 1.59L7.28 14.341Z",
    fill: "#26890D"
  })));
};
export default SvgGreenCheck;